import React from "react";
//images
import heroimg from "../../../assets/images/pages/training.jpg";

// components
import HeroSection from "../../../components/ui/Cards/Hero";

// state
import { get_trainings } from "../../../service/api/training";
import { useAppDispatch, useAppSelector } from "../../../store";
import TrainingCard from "../misc/TrainingCard";
// import CustomHeader from "../../../components/ui/CustomHeader/CustomHeader";

const Training = () => {
  const dispatch = useAppDispatch();
  const { trainings, limit, offset } = useAppSelector(
    ({ training }) => training,
  );

  console.log("training", trainings);

  const onLoad = React.useCallback(() => {
    get_trainings(dispatch, limit, offset);
  }, [dispatch, limit, offset]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="w-full">
      <HeroSection
        title="Corporate Setup Trainings"
        titleColor="text-primary-900"
        description="We offer a wide range of training programs to help you and your team stay ahead in the ever-evolving corporate landscape. Whether you're looking to enhance your skills, improve team collaboration, or stay updated with the latest industry trends, we have the right training program for you. "
        descriptionColor="text-primary-900"
        buttonText="Learn More"
        buttonLink="https://training.corporate-setup.com/courses/"
        imageSrc={heroimg}
        imageAlt="Hero Section"
        imagePosition="left"
        imagePositionBgColor="bg-white/30"
        imageRotation="-rotate-3"
        background="bg-customyellow"
        buttonbg="bg-primary-900"
        buttonTextColor="text-white"
        buttonHoverBg="bg-primary-800"
        paddingtop="pt-20"
      />

      <section className="py-12 md:py-24 lg:py-32 bg-customgreen">
        <div className="max-w-7xl px-6 xl:px-0 mx-auto">
          <div className="flex flex-col items-center justify-center space-y-4 text-center mb-12">
            <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-primary-900">
              Trainings
            </h2>
            <p className="max-w-[700px] text-primary-700 md:text-xl/relaxed ">
              Get started with our structured training programs designed to help
              your business succeed.
            </p>
          </div>

          {/* Training card should go here */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {trainings.map((training) => (
              <TrainingCard key={training.id} training={training} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Training;
